/* Hair Monster · Shopping assistant ("Let us pick") + the optional invitation. No dependencies.
   Open it from anywhere with a link to #find-my-look, an element with data-hm-pick-open="source",
   or window.HMPick.open('source'). One question at a time:
   vibe -> occasion (-> specific occasion) -> one recommended wig -> the real product page. */
(function () {
  if (window.HMPick) return;

  var HASH = '#find-my-look';
  var STORE = 'hm_pick';
  var USED = 'hm_pick_used';
  var INVITE_SEEN = 'hm_inv_seen';
  var root = document.documentElement;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var design = !!(window.Shopify && window.Shopify.designMode);
  var STEP = { vibe: 1, occasion: 2, more: 2, look: 3 };
  var editorReopen = {};

  function $(r, s) { return r.querySelector(s); }
  function $$(r, s) { return Array.prototype.slice.call(r.querySelectorAll(s)); }
  function ss(key, val) {
    try {
      if (val === undefined) return JSON.parse(sessionStorage.getItem(key) || 'null');
      if (val === null) sessionStorage.removeItem(key);
      else sessionStorage.setItem(key, JSON.stringify(val));
    } catch (e) { return null; }
  }
  function track(action, detail) {
    if (design) return;
    var d = { action: action };
    for (var k in detail || {}) d[k] = detail[k];
    try { if (window.Shopify && Shopify.analytics && Shopify.analytics.publish) Shopify.analytics.publish('hm_pick', d); } catch (e) {}
    try {
      var dl = { event: 'hm_pick', hm_pick_action: action };
      for (var j in detail || {}) dl['hm_pick_' + j] = detail[j];
      (window.dataLayer = window.dataLayer || []).push(dl);
    } catch (e) {}
  }
  function idle(fn) { (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(fn); }
  function sized(url, w) { return url ? url.replace(/([?&])width=\d+/, '$1width=' + w) : url; }

  /* ---------- Page scroll lock (keeps the page from jumping when the scrollbar disappears) ---------- */
  var locked = false;
  function lock() {
    if (locked) return;
    locked = true;
    var gap = window.innerWidth - root.clientWidth;
    root.style.overflow = 'hidden';
    document.body.style.overflow = 'hidden';
    if (gap > 0) document.body.style.paddingRight = gap + 'px';
  }
  function unlock() {
    if (!locked) return;
    locked = false;
    root.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.paddingRight = '';
  }

  /* ---------- The assistant ---------- */
  function Assistant(dlg) {
    var self = this;
    var raw = dlg.parentNode && $(dlg.parentNode, '[data-hm-pick-data]');
    try { this.data = JSON.parse(raw.textContent); } catch (e) { this.data = { matches: [] }; }
    dlg._hmPick = this;
    this.dlg = dlg;
    this.key = dlg.getAttribute('data-key');
    this.panel = $(dlg, '.hm-pick__panel');
    this.body = $(dlg, '[data-hm-pick-body]');
    this.screens = {};
    $$(dlg, '[data-hm-pick-screen]').forEach(function (el) { self.screens[el.getAttribute('data-hm-pick-screen')] = el; });
    this.vibes = $$(dlg, '[data-hm-pick-vibe]');
    this.occs = $$(dlg, '[data-hm-pick-occ]');
    this.subs = $$(dlg, '[data-hm-pick-sub]');
    this.backBtn = $(dlg, '[data-hm-pick-back]');
    this.dots = $$(dlg, '.hm-pick__dots li');
    this.r = {
      result: $(dlg, '[data-hm-pick-result]'),
      chip: $(dlg, '[data-hm-pick-chip]'),
      loading: $(dlg, '[data-hm-pick-loading]'),
      pick: $(dlg, '[data-hm-pick-pick]'),
      name: $(dlg, '[data-hm-pick-name]'),
      price: $(dlg, '[data-hm-pick-price]'),
      was: $(dlg, '[data-hm-pick-was]'),
      why: $(dlg, '[data-hm-pick-why]'),
      note: $(dlg, '[data-hm-pick-note]'),
      cta: $(dlg, '[data-hm-pick-cta]'),
      ctaLabel: $(dlg, '[data-hm-pick-cta-label]'),
      another: $(dlg, '[data-hm-pick-another]'),
      alts: $(dlg, '[data-hm-pick-alts]'),
      pols: $(dlg, '[data-hm-pick-pols]'),
      live: $(dlg, '[data-hm-pick-live]')
    };
    this.ctaText = this.r.ctaLabel ? this.r.ctaLabel.textContent : '';
    this.remember = dlg.hasAttribute('data-remember') && !design;
    this.cache = {};
    this.token = 0;
    this.busy = false;
    this.screen = 'vibe';
    this.state = { v: 0, o: '', s: '' };
    var saved = this.remember ? ss(STORE) : null;
    if (saved && saved.v && this.vibes[saved.v - 1]) {
      this.state.v = saved.v;
      if (saved.o && this.occByKey(saved.o)) this.state.o = String(saved.o);
      if (saved.s && this.subByKey(saved.s)) this.state.s = String(saved.s);
    }
    this.bind();
    this.mark();
  }

  Assistant.prototype.occByKey = function (k) { return this.occs.filter(function (b) { return b.getAttribute('data-hm-pick-occ') === String(k); })[0]; };
  Assistant.prototype.subByKey = function (k) { return this.subs.filter(function (b) { return b.getAttribute('data-hm-pick-sub') === String(k); })[0]; };
  Assistant.prototype.isMore = function (o) { var b = this.occByKey(o); return !!(b && b.hasAttribute('data-more') && this.subs.length); };
  Assistant.prototype.isOpen = function () { return this.dlg.hasAttribute('open'); };
  Assistant.prototype.names = function () {
    var st = this.state, v = this.vibes[st.v - 1], o = this.occByKey(st.o), s = st.s ? this.subByKey(st.s) : null;
    return {
      vibe: v ? v.getAttribute('data-name') : '',
      occasion: o ? o.getAttribute('data-name') : '',
      specific: s ? s.getAttribute('data-name') : ''
    };
  };

  Assistant.prototype.bind = function () {
    var self = this, dlg = this.dlg;
    dlg.addEventListener('click', function (e) {
      if (e.target === dlg) { self.close('backdrop'); return; }
      var t = e.target.closest ? e.target.closest('button, a') : null;
      if (!t || !dlg.contains(t)) return;
      if (t.hasAttribute('data-hm-pick-vibe')) self.pickVibe(+t.getAttribute('data-hm-pick-vibe'));
      else if (t.hasAttribute('data-hm-pick-occ')) self.pickOcc(t.getAttribute('data-hm-pick-occ'));
      else if (t.hasAttribute('data-hm-pick-sub')) self.pickSub(t.getAttribute('data-hm-pick-sub'));
      else if (t.hasAttribute('data-hm-pick-back')) self.back();
      else if (t.hasAttribute('data-hm-pick-close')) self.close('button');
      else if (t.hasAttribute('data-hm-pick-restart')) self.restart();
      else if (t.hasAttribute('data-hm-pick-product')) {
        if (t.getAttribute('aria-disabled') === 'true' || t.getAttribute('href') === '#') { e.preventDefault(); return; }
        var n = self.names();
        self.leaving = true;
        track('product_click', { product: t.getAttribute('data-handle') || '', rank: t.getAttribute('data-hm-pick-product'), vibe: n.vibe, occasion: n.specific || n.occasion });
      }
    });
    // Esc: close our way (focus goes back, the dismissal is counted)
    dlg.addEventListener('cancel', function (e) { e.preventDefault(); self.close('escape'); });
    // Closed some other way (e.g. by the browser): count it and tidy up
    dlg.addEventListener('close', function () {
      // Ignore a late event from an earlier close if she has already reopened it
      if (!self.opened || dlg.hasAttribute('open')) return;
      if (!self.leaving) { var n = self.names(); track('dismiss', { method: 'other', screen: self.screen, vibe: n.vibe, occasion: n.specific || n.occasion }); }
      self.finish('other');
    });
    // Keep Tab inside the pop-up
    dlg.addEventListener('keydown', function (e) {
      if (e.key !== 'Tab') return;
      var f = $$(self.panel, 'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), summary, [tabindex]:not([tabindex="-1"])').filter(function (el) {
        return !el.closest('[hidden]') && el.getClientRects().length;
      });
      if (!f.length) return;
      var first = f[0], last = f[f.length - 1], a = document.activeElement;
      if (e.shiftKey && (a === first || !self.panel.contains(a))) { e.preventDefault(); last.focus(); }
      else if (!e.shiftKey && (a === last || !self.panel.contains(a))) { e.preventDefault(); first.focus(); }
    });
    // Warm up the likely next product as she hovers or touches a card
    function warm(e) {
      var t = e.target.closest ? e.target.closest('[data-hm-pick-occ], [data-hm-pick-sub]') : null;
      if (!t || !self.state.v) return;
      var key = t.getAttribute('data-hm-pick-sub') || t.getAttribute('data-hm-pick-occ');
      if (t.hasAttribute('data-more')) return;
      var m = self.match(self.state.v, t.hasAttribute('data-hm-pick-sub') ? self.state.o : key, t.hasAttribute('data-hm-pick-sub') ? key : '');
      if (m) self.load(m.p);
    }
    dlg.addEventListener('pointerover', warm);
    dlg.addEventListener('focusin', warm);
    dlg.addEventListener('touchstart', warm, { passive: true });
  };

  Assistant.prototype.resumeScreen = function () {
    var st = this.state;
    if (st.v && st.o && (!this.isMore(st.o) || st.s)) return 'look';
    if (st.v && st.o && this.isMore(st.o)) return 'more';
    if (st.v) return 'occasion';
    return 'vibe';
  };

  Assistant.prototype.open = function (source, screen) {
    if (this.opened && this.isOpen()) { if (screen) this.show(screen, 0); return; }
    if (active && active !== this && active.opened) active.close('switch');
    active = this;
    this.opener = document.activeElement;
    this.source = source || 'link';
    this.leaving = false;
    this.opened = true;
    lock();
    var d = this.dlg;
    try { if (d.showModal) d.showModal(); else d.setAttribute('open', ''); } catch (e) { d.setAttribute('open', ''); }
    root.setAttribute('data-hm-quiet', '');
    root.setAttribute('data-hm-pick-active', '');
    this.warmImages(this.screens.vibe);
    var start = screen || this.resumeScreen();
    this.show(start, 0, true);
    if (!design) ss(USED, 1);
    track('open', { source: this.source, screen: start });
    try { document.dispatchEvent(new CustomEvent('hm:pick:open', { detail: { source: this.source } })); } catch (e) {}
  };

  Assistant.prototype.close = function (method) {
    if (!this.opened) return;
    if (!this.leaving && method !== 'editor' && method !== 'switch') {
      var n = this.names();
      track('dismiss', { method: method || 'other', screen: this.screen, vibe: n.vibe, occasion: n.specific || n.occasion });
    }
    this.finish(method);
  };

  Assistant.prototype.finish = function (method) {
    if (!this.opened) return;
    this.opened = false;
    var d = this.dlg;
    if (d.hasAttribute('open')) { try { if (d.close) d.close(); else d.removeAttribute('open'); } catch (e) { d.removeAttribute('open'); } }
    unlock();
    root.removeAttribute('data-hm-pick-active');
    root.removeAttribute('data-hm-quiet');
    if (location.hash === HASH && window.history && history.replaceState) history.replaceState(history.state, '', location.pathname + location.search);
    var o = this.opener;
    this.opener = null;
    if (o && o.focus && document.contains(o) && method !== 'switch') { try { o.focus({ preventScroll: true }); } catch (e) { o.focus(); } }
    try { document.dispatchEvent(new CustomEvent('hm:pick:close')); } catch (e) {}
  };

  Assistant.prototype.show = function (name, dir, instant) {
    var self = this, next = this.screens[name];
    if (!next) return;
    Object.keys(this.screens).forEach(function (k) { if (self.screens[k] !== next) self.screens[k].hidden = true; });
    next.hidden = false;
    this.dlg.classList.toggle('is-back', dir < 0);
    next.classList.remove('is-in');
    if (!instant && !reduce) { void next.offsetWidth; next.classList.add('is-in'); }
    this.screen = name;
    this.dlg.setAttribute('data-screen', name);
    if (this.backBtn) this.backBtn.hidden = name === 'vibe';
    var step = STEP[name] || 1;
    this.dots.forEach(function (li, i) { li.className = i + 1 < step ? 'is-done' : (i + 1 === step ? 'is-on' : ''); });
    if (this.body) this.body.scrollTop = 0;
    var h = $(next, '[data-hm-pick-title]');
    if (h) {
      this.dlg.setAttribute('aria-labelledby', h.id);
      try { h.focus({ preventScroll: true }); } catch (e) { h.focus(); }
    }
    this.mark();
    if (name === 'look') this.renderLook();
    if (name === 'occasion') this.warmImages(next);
    if (name === 'more') { this.warmImages(next); this.prefetch(true); }
  };

  Assistant.prototype.mark = function () {
    var st = this.state;
    function set(list, attr, val) {
      var any = false;
      list.forEach(function (b) {
        var on = b.getAttribute(attr) === String(val);
        b.classList.toggle('is-on', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) any = true;
      });
      if (list[0]) list[0].parentNode.classList.toggle('has-pick', any);
    }
    set(this.vibes, 'data-hm-pick-vibe', st.v || '');
    set(this.occs, 'data-hm-pick-occ', st.o);
    set(this.subs, 'data-hm-pick-sub', st.s);
  };

  Assistant.prototype.save = function () { if (this.remember) ss(STORE, this.state); };

  Assistant.prototype.later = function (fn) {
    var self = this;
    if (this.busy) return;
    this.busy = true;
    setTimeout(function () { self.busy = false; fn(); }, reduce ? 0 : 170);
  };

  Assistant.prototype.pickVibe = function (n) {
    if (this.busy) return;
    this.state.v = n;
    this.save();
    this.mark();
    track('identity', { vibe: this.names().vibe });
    this.warmImages(this.screens.occasion);
    this.warmImages(this.screens.look);
    this.prefetch(false);
    var self = this;
    this.later(function () { self.show('occasion', 1); });
  };

  Assistant.prototype.pickOcc = function (o) {
    if (this.busy) return;
    var self = this, more = this.isMore(o);
    if (this.state.o !== String(o)) this.state.s = '';
    this.state.o = String(o);
    if (!more) this.state.s = '';
    this.save();
    this.mark();
    if (more) {
      this.warmImages(this.screens.more);
      track('more_occasions', { vibe: this.names().vibe });
      this.later(function () { self.show('more', 1); });
      return;
    }
    var n = this.names();
    track('occasion', { vibe: n.vibe, occasion: n.occasion });
    this.later(function () { self.show('look', 1); });
  };

  Assistant.prototype.pickSub = function (s) {
    if (this.busy) return;
    var self = this;
    this.state.s = String(s);
    this.save();
    this.mark();
    var n = this.names();
    track('occasion', { vibe: n.vibe, occasion: n.specific, group: n.occasion });
    this.later(function () { self.show('look', 1); });
  };

  Assistant.prototype.back = function () {
    var to = { look: this.state.s ? 'more' : 'occasion', more: 'occasion', occasion: 'vibe' }[this.screen];
    if (to) this.show(to, -1);
  };

  Assistant.prototype.restart = function () {
    this.state = { v: 0, o: '', s: '' };
    this.save();
    track('start_over', {});
    this.show('vibe', -1);
  };

  /* Which rule applies: exact match first, then the "More occasions" rule for a specific occasion */
  Assistant.prototype.match = function (v, o, s) {
    var key = s || o, exact = null, group = null;
    (this.data.matches || []).forEach(function (m) {
      if (m.v !== v) return;
      if (!exact && m.o === key) exact = m;
      if (s && !group && m.o === o) group = m;
    });
    return exact || group;
  };

  Assistant.prototype.load = function (handle) {
    var self = this;
    if (!handle) return Promise.resolve(null);
    if (!this.cache[handle]) {
      this.cache[handle] = fetch(this.data.url + encodeURIComponent(handle) + '?section_id=hm-pick-data', { credentials: 'same-origin' })
        .then(function (r) { return r.ok ? r.text() : ''; })
        .then(function (t) {
          if (!t) return null;
          var doc = new DOMParser().parseFromString(t, 'text/html');
          var el = doc.querySelector('[data-hm-pick-product]');
          return el ? JSON.parse(el.textContent) : null;
        })
        .catch(function () { delete self.cache[handle]; return null; });
    }
    return this.cache[handle];
  };

  Assistant.prototype.prefetch = function (subs) {
    var self = this, st = this.state;
    idle(function () {
      (subs ? self.subs : self.occs).forEach(function (b) {
        if (b.hasAttribute('data-more')) return;
        var m = subs ? self.match(st.v, st.o, b.getAttribute('data-hm-pick-sub')) : self.match(st.v, b.getAttribute('data-hm-pick-occ'), '');
        if (m) self.load(m.p);
      });
    });
  };

  Assistant.prototype.warmImages = function (scope) {
    if (!scope) return;
    $$(scope, 'img[loading="lazy"]').forEach(function (img) { img.loading = 'eager'; });
  };

  /* First in-stock wig: the pick, then its backups, then the go-to wig */
  Assistant.prototype.resolve = function (m) {
    var self = this;
    var list = [];
    if (m) [m.p].concat(m.b || []).forEach(function (h) { if (h && list.indexOf(h) < 0) list.push(h); });
    var i = 0;
    function next() {
      if (i >= list.length) {
        var fb = self.data.fallback;
        if (!fb || list.indexOf(fb) >= 0) return Promise.resolve({ p: null, kind: 'none', list: list });
        return self.load(fb).then(function (p) { return p && p.a ? { p: p, kind: 'fallback', list: list } : { p: null, kind: 'none', list: list }; });
      }
      var h = list[i++];
      return self.load(h).then(function (p) {
        if (p && p.a) return { p: p, kind: i === 1 ? 'primary' : 'backup', list: list };
        return next();
      });
    }
    return next();
  };

  Assistant.prototype.renderLook = function () {
    var self = this, r = this.r, st = this.state, n = this.names();
    var token = ++this.token;
    var m = this.match(st.v, st.o, st.s);
    if (r.chip) {
      r.chip.textContent = '';
      r.chip.appendChild(document.createTextNode(n.vibe + ' '));
      var b = document.createElement('b'); b.textContent = (this.data.join || '×').trim(); r.chip.appendChild(b);
      r.chip.appendChild(document.createTextNode(' ' + (n.specific || n.occasion)));
    }
    r.result.classList.add('is-loading');
    if (r.loading) r.loading.hidden = false;
    r.pick.hidden = true;
    r.note.hidden = true;
    if (r.another) { r.another.hidden = true; r.another.open = false; }
    r.cta.setAttribute('aria-disabled', 'true');
    this.resolve(m).then(function (res) {
      if (token !== self.token) return;
      self.paint(res, m);
    });
  };

  Assistant.prototype.paint = function (res, m) {
    var r = this.r, d = this.data, p = res.p, n = this.names(), self = this;
    r.result.classList.remove('is-loading');
    if (r.loading) r.loading.hidden = true;
    r.cta.removeAttribute('aria-disabled');
    if (!p) {
      r.pick.hidden = true;
      r.note.textContent = d.none || '';
      r.note.hidden = !d.none;
      r.cta.href = d.noneUrl || '/collections/all';
      r.cta.setAttribute('data-handle', '');
      r.ctaLabel.textContent = d.noneLabel || this.ctaText;
      this.polaroids(null);
      if (r.live) r.live.textContent = d.none || '';
      track('recommendation', { vibe: n.vibe, occasion: n.specific || n.occasion, product: '', result: 'none' });
      return;
    }
    r.ctaLabel.textContent = this.ctaText;
    r.name.textContent = p.t;
    r.name.href = p.url;
    r.name.setAttribute('data-handle', p.h);
    r.price.textContent = p.p;
    r.was.textContent = p.c || '';
    r.why.textContent = res.kind === 'primary' ? (m && m.why) || '' : '';
    r.pick.hidden = false;
    var note = res.kind === 'backup' ? d.soldOut : (res.kind === 'fallback' ? d.favorite : '');
    r.note.textContent = note || '';
    r.note.hidden = !note;
    r.cta.href = p.url;
    r.cta.setAttribute('data-handle', p.h);
    this.polaroids(p);
    if (r.live) r.live.textContent = (d.found || '') + ' ' + p.t + ', ' + p.p;
    track('recommendation', { vibe: n.vibe, occasion: n.specific || n.occasion, product: p.h, result: res.kind });
    // Up to 2 other in-stock looks, folded away
    if (r.another && this.dlg.hasAttribute('data-backups')) {
      var others = res.list.filter(function (h) { return h !== p.h; });
      Promise.all(others.map(function (h) { return self.load(h); })).then(function (list) {
        if (self.r.cta.getAttribute('data-handle') !== p.h) return;
        var ok = list.filter(function (x) { return x && x.a && x.h !== p.h; }).slice(0, 2);
        r.alts.textContent = '';
        ok.forEach(function (x) {
          var li = document.createElement('li');
          var a = document.createElement('a');
          a.href = x.url;
          a.className = 'hm-pick__alt';
          a.setAttribute('data-hm-pick-product', 'backup');
          a.setAttribute('data-handle', x.h);
          if (x.i && x.i[0]) {
            var img = document.createElement('img');
            img.src = sized(x.i[0].u, 160); img.alt = ''; img.width = 64; img.height = 68; img.loading = 'lazy'; img.decoding = 'async';
            a.appendChild(img);
          }
          var t = document.createElement('span'); t.className = 'hm-pick__alt-name'; t.textContent = x.t; a.appendChild(t);
          var pr = document.createElement('span'); pr.className = 'hm-pick__alt-price'; pr.textContent = x.p; a.appendChild(pr);
          li.appendChild(a);
          r.alts.appendChild(li);
        });
        r.another.hidden = !ok.length;
      });
    }
  };

  Assistant.prototype.polaroids = function (p) {
    var pols = this.r.pols;
    if (!pols) return;
    pols.classList.toggle('is-empty', !p);
    var nodes = $$(pols, '[data-hm-pick-pol]');
    function fill() {
      nodes.forEach(function (node) {
        var i = +node.getAttribute('data-hm-pick-pol');
        var img = p && p.i && p.i[i];
        if (node.tagName === 'A') { node.href = p ? p.url : '#'; node.setAttribute('data-handle', p ? p.h : ''); }
        node.textContent = '';
        if (!img) return;
        var el = document.createElement('img');
        el.src = img.u;
        el.alt = i === 0 ? (p.alt || p.t) : '';
        el.width = img.w; el.height = img.h;
        el.decoding = 'async';
        node.appendChild(el);
      });
    }
    if (reduce || this.shownHandle === undefined || !p) { fill(); this.shownHandle = p ? p.h : null; return; }
    if (this.shownHandle === p.h) return;
    this.shownHandle = p.h;
    pols.classList.add('is-swap');
    setTimeout(function () { fill(); requestAnimationFrame(function () { pols.classList.remove('is-swap'); }); }, 180);
  };

  /* Theme editor: show the screen for whatever block is selected */
  Assistant.prototype.preview = function (el) {
    if (!el) return;
    var self = this;
    if (el.hasAttribute('data-hm-pick-vibe')) { this.open('editor', 'vibe'); return; }
    if (el.hasAttribute('data-hm-pick-occ')) { this.open('editor', 'occasion'); return; }
    if (el.hasAttribute('data-hm-pick-sub')) { if (!this.state.v) this.state.v = 1; this.open('editor', 'more'); return; }
    var id = el.getAttribute('data-hm-pick-match');
    (this.data.matches || []).forEach(function (m) {
      if (m.id !== id) return;
      self.state.v = m.v;
      if (m.o.charAt(0) === 'm') {
        var moreCard = self.occs.filter(function (b) { return b.hasAttribute('data-more'); })[0];
        self.state.o = moreCard ? moreCard.getAttribute('data-hm-pick-occ') : '';
        self.state.s = m.o;
      } else { self.state.o = m.o; self.state.s = ''; }
      if (self.isOpen()) self.show('look', 0, true); else self.open('editor', 'look');
    });
  };

  Assistant.prototype.destroy = function () {
    this.leaving = true;
    this.close('editor');
    if (active === this) active = null;
  };

  /* ---------- The invitation (optional, once per visit, never over the assistant) ---------- */
  function Invite(el) {
    var self = this;
    this.el = el;
    el._hmInvite = this;
    this.delay = Math.max(3, +el.getAttribute('data-delay') || 15) * 1000;
    el.addEventListener('click', function (e) {
      var t = e.target.closest ? e.target.closest('[data-hm-inv-close], [data-hm-pick-open]') : null;
      if (!t) return;
      if (t.hasAttribute('data-hm-inv-close')) { self.hide(); track('invite_dismiss', { method: t.getAttribute('data-hm-inv-close') || 'close' }); }
      else self.hide(true);
    });
    el.addEventListener('keydown', function (e) { if (e.key === 'Escape') { self.hide(); track('invite_dismiss', { method: 'escape' }); } });
    document.addEventListener('hm:pick:open', function () { clearTimeout(self.timer); self.hide(true); });
    if (design) return;
    if (ss(INVITE_SEEN) || ss(USED)) return;
    this.timer = setTimeout(function tick() {
      if (ss(USED) || ss(INVITE_SEEN)) return;
      if (!getActive() || root.hasAttribute('data-hm-quiet') || pageBusy()) { self.timer = setTimeout(tick, 4000); return; }
      self.show();
    }, this.delay);
  }
  function pageBusy() {
    // A drawer, menu or search is open, or the shopper is typing
    if (/\boverflow-hidden/.test(document.body.className)) return true;
    var a = document.activeElement;
    if (a && (a.tagName === 'INPUT' || a.tagName === 'TEXTAREA' || a.tagName === 'SELECT')) return true;
    return !!document.querySelector('cart-drawer.active, .drawer.active, details-modal details[open], header-drawer details[open], header details[open]');
  }
  Invite.prototype.show = function (fromEditor) {
    var el = this.el;
    el.hidden = false;
    requestAnimationFrame(function () { el.classList.add('is-in'); });
    if (!fromEditor) { ss(INVITE_SEEN, 1); track('invite_shown', {}); }
  };
  Invite.prototype.hide = function (quick) {
    var el = this.el;
    if (el.hidden) return;
    el.classList.remove('is-in');
    if (quick || reduce) { el.hidden = true; return; }
    setTimeout(function () { el.hidden = true; }, 260);
  };

  /* ---------- Wiring ---------- */
  var active = null;
  function getActive() {
    if (active && document.contains(active.dlg)) return active;
    var d = document.querySelector('dialog[data-hm-pick]');
    active = d ? (d._hmPick || null) : null;
    return active;
  }
  function boot(scope) {
    $$(scope || document, 'dialog[data-hm-pick]').forEach(function (d) { if (!d._hmPick) new Assistant(d); });
    $$(scope || document, '[data-hm-invite]').forEach(function (el) { if (!el._hmInvite) new Invite(el); });
  }
  function instFor(target) {
    if (!target) return null;
    var d = (target.matches && target.matches('dialog[data-hm-pick]')) ? target : (target.closest && target.closest('dialog[data-hm-pick]')) || (target.querySelector && target.querySelector('dialog[data-hm-pick]'));
    return d ? d._hmPick : null;
  }
  function invFor(target) {
    if (!target) return null;
    var el = (target.closest && target.closest('[data-hm-invite]')) || (target.querySelector && target.querySelector('[data-hm-invite]'));
    return el ? el._hmInvite : null;
  }

  // Any link to #find-my-look, or any [data-hm-pick-open], opens the assistant
  document.addEventListener('click', function (e) {
    if (e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var t = e.target.closest ? e.target.closest('[data-hm-pick-open], a[href*="' + HASH + '"]') : null;
    if (!t || t === root || t === document.body || (e.defaultPrevented && !t.hasAttribute('data-hm-pick-open'))) return;
    var a = getActive();
    if (!a) return;
    e.preventDefault();
    a.open(t.getAttribute('data-hm-pick-open') || 'link');
  });
  window.addEventListener('hashchange', function () { if (location.hash === HASH && getActive()) getActive().open('link'); });

  // Theme editor
  document.addEventListener('shopify:section:select', function (e) {
    var a = instFor(e.target); if (a) a.open('editor');
    var i = invFor(e.target); if (i) i.show(true);
  });
  document.addEventListener('shopify:section:deselect', function (e) {
    var a = instFor(e.target); if (a) { a.leaving = true; a.close('editor'); }
    var i = invFor(e.target); if (i) i.hide(true);
  });
  document.addEventListener('shopify:block:select', function (e) { var a = instFor(e.target); if (a) a.preview(e.target); });
  document.addEventListener('shopify:section:unload', function (e) {
    var a = instFor(e.target);
    if (a) { editorReopen[a.key] = a.isOpen() ? a.screen : null; a.destroy(); }
  });
  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
    var a = instFor(e.target);
    if (a && editorReopen[a.key]) a.open('editor', editorReopen[a.key]);
    var i = invFor(e.target); if (i && design) i.show(true);
  });

  window.HMPick = {
    open: function (source) { var a = getActive(); if (a) a.open(source || 'script'); return !!a; },
    close: function () { var a = getActive(); if (a) a.close('script'); },
    isOpen: function () { var a = getActive(); return !!(a && a.isOpen()); }
  };

  function start() {
    boot();
    var a = getActive();
    if (!a) return;
    if (location.hash === HASH) a.open('url');
    // Load the three vibe photos once the page is idle, so the pop-up opens with them ready
    function warmLater() { setTimeout(function () { idle(function () { a.warmImages(a.screens.vibe); }); }, 2500); }
    if (document.readyState === 'complete') warmLater(); else window.addEventListener('load', warmLater);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  // Back from the product page (page restored from the back/forward cache)
  window.addEventListener('pageshow', function (e) {
    if (!e.persisted) return;
    var a = getActive();
    if (a && a.opened) { a.leaving = false; lock(); }
  });
})();
